import { Environment, SgAuthAdapter } from '@sg/common';
import { SgAppConfig } from '../app-bootstrap';
import { AppEnvironmentApi } from './base';

const environment: Environment = {
  async: true,
  production: true,
  env: 'prod',
  adal: {
    tenant: 'sharegain.com',
    clientId: '5ee9488b-559a-4d4c-b515-17338442f91a'
  },
  oidc: {
    authority: 'https://api-dev.sharegain.com/identity',
    client_id: 'js',
    filterProtocolClaims: true,
    loadUserInfo: true,
    automaticSilentRenew: false,
    silentRequestTimeout: 10000,
    prompt: 'login'
  },
  oidcRenewPolicy: {
    interval: 10,
    renewWhenExpiresIn: 50,
    retries: 2
  },
  api: {
    SHARED: {
      basePath: 'https://api-dev.sharegain.com',
      withCredentials: true
    }
  },
  ws: {
    baseUrl: 'https://api-dev.sharegain.com/signalr'
  },
  i18n: {
    default: 'en',
    langs: {
      en: {
        key: 'en',
        globalName: 'English'
      },
      he: {
        key: 'he',
        globalName: 'Hebrew',
        localName: 'עברית',
        rtl: true
      }
    }
  },
  idle: [60, 360],
  featureFlag: {
    isLegalEntityResourceHubSettingsDisplayed: true,
    isLegalEntitySmartPortfolioInsightsSettingsDisplayed: true,
    isOneClickAnalyzerEnabled: true,
  },
  hotjar: {},
  heap: {},
  pendo: {},
  loggly: {
    key: '431152b9-7c4d-4ffb-b96b-6f7a502540a3',
    tag: 'development'
  },
};

const login = {
  byPass(appConfig: SgAppConfig): boolean {
    return !!window['Cypress'] && !!window['Cypress']['__AUTH_ADAPTER__'];
  },
  adapter(appConfig: SgAppConfig, env: Environment): SgAuthAdapter {
    return window['Cypress']['__AUTH_ADAPTER__'];
  }
};

export const envApi: AppEnvironmentApi = {
  environment,
  login,
};
